import { useQueries } from "@tanstack/react-query";
import {
  GeneralsBoard as GeneralsBoardView,
  isReplay,
} from "@softmax/product-ux/catalog";

const replaySources = [
  "/generals/replay-06.json",
  "/generals/replay-07.json",
  "/generals/replay-08.json",
] as const;

export function GeneralsBoard({ size = 416 }: { size?: number }) {
  const replays = useQueries({
    queries: replaySources.map((url) => ({
      queryKey: ["generals-preview-replay", url],
      staleTime: Infinity,
      queryFn: async ({ signal }: { signal: AbortSignal }) => {
        const response = await fetch(url, { signal });

        if (!response.ok)
          throw new Error(`Replay ${url}: HTTP ${response.status}`);

        const body: unknown = await response.json();

        if (!isReplay(body))
          throw new Error(`Replay ${url}: invalid recording`);

        return body;
      },
    })),
  });
  const failed = replays.some((query) => query.isError);
  return (
    <div className="relative">
      <GeneralsBoardView
        replays={replays.flatMap((query) =>
          query.data ? [query.data] : query.isError ? [null] : [],
        )}
        size={size}
      />
      {failed && (
        <button
          type="button"
          className="absolute bottom-2 left-2 rounded bg-white/90 px-2 py-1 text-xs"
          onClick={() => {
            for (const query of replays)
              if (query.isError) void query.refetch();
          }}
        >
          Replay unavailable · Retry
        </button>
      )}
    </div>
  );
}
